/**
 * Created by Arif Topcu in 2019
 */

import FactorAttributionSelector from './FactorAttributionSelector';

export default FactorAttributionSelector;
